/**
 * @generated SignedSource<<45c9d5aa9c36ec9841b1d319c8c2d6a9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReportSource = "BINDING" | "POLICY" | "%future added value";
export type UpsertReportGroupsInput = {
  reportGroups?: ReadonlyArray<ReportGroupInput | null | undefined> | null | undefined;
};
export type ReportGroupInput = {
  bindings?: ReadonlyArray<string> | null | undefined;
  emailSettings?: ReadonlyArray<EmailSettingsInput | null | undefined> | null | undefined;
  enabled?: boolean | null | undefined;
  groupBy: ReadonlyArray<string | null | undefined>;
  jiraSettings?: ReadonlyArray<JiraSettingsInput | null | undefined> | null | undefined;
  msteamsSettings?: ReadonlyArray<MSTeamsSettingsInput | null | undefined> | null | undefined;
  name: string;
  schedule: string;
  serviceNowSettings?: ReadonlyArray<ServiceNowSettingsInput | null | undefined> | null | undefined;
  slackSettings?: ReadonlyArray<SlackSettingsInput | null | undefined> | null | undefined;
  source: ReportSource;
  symphonySettings?: ReadonlyArray<SymphonySettingsInput | null | undefined> | null | undefined;
  teamsSettings?: ReadonlyArray<TeamsSettingsInput | null | undefined> | null | undefined;
  useMessageSettings: boolean;
};
export type EmailSettingsInput = {
  cc?: ReadonlyArray<string | null | undefined> | null | undefined;
  firstMatchOnly?: boolean | null | undefined;
  format?: string | null | undefined;
  fromEmail?: string | null | undefined;
  priority?: string | null | undefined;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  subject: string;
  template: string;
};
export type RecipientInput = {
  account_owner?: boolean | null | undefined;
  event_owner?: boolean | null | undefined;
  resource_owner?: boolean | null | undefined;
  tag?: string | null | undefined;
  value?: string | null | undefined;
};
export type SlackSettingsInput = {
  firstMatchOnly?: boolean | null | undefined;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  template: string;
};
export type TeamsSettingsInput = {
  firstMatchOnly?: boolean | null | undefined;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  template: string;
};
export type MSTeamsSettingsInput = {
  firstMatchOnly?: boolean | null | undefined;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  template: string;
};
export type ServiceNowSettingsInput = {
  firstMatchOnly?: boolean | null | undefined;
  impact: string;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  shortDescription: string;
  template: string;
  urgency: string;
};
export type JiraSettingsInput = {
  description: string;
  firstMatchOnly?: boolean | null | undefined;
  project: string;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  summary: string;
  template: string;
};
export type SymphonySettingsInput = {
  firstMatchOnly?: boolean | null | undefined;
  recipients?: ReadonlyArray<RecipientInput> | null | undefined;
  template: string;
};
export type UpsertReportGroupsMutation$variables = {
  connections: ReadonlyArray<string>;
  input?: UpsertReportGroupsInput | null | undefined;
};
export type UpsertReportGroupsMutation$data = {
  readonly upsertReportGroups: {
    readonly reportGroups: ReadonlyArray<{
      readonly deliverySettings: ReadonlyArray<{
        readonly description?: string;
        readonly firstMatchOnly?: boolean | null | undefined;
        readonly impact?: string;
        readonly project?: string;
        readonly recipients?: ReadonlyArray<{
          readonly account_owner: boolean | null | undefined;
          readonly event_owner: boolean | null | undefined;
          readonly resource_owner: boolean | null | undefined;
          readonly tag: string | null | undefined;
          readonly value: string | null | undefined;
        }> | null | undefined;
        readonly shortDescription?: string;
        readonly subject?: string;
        readonly summary?: string;
        readonly template?: string;
        readonly type?: string;
        readonly urgency?: string;
      } | null | undefined> | null | undefined;
      readonly enabled: boolean;
      readonly groupBy: ReadonlyArray<string> | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly schedule: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type UpsertReportGroupsMutation = {
  response: UpsertReportGroupsMutation$data;
  variables: UpsertReportGroupsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstMatchOnly",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "account_owner",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "event_owner",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resource_owner",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Recipient",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": true,
  "selections": [
    (v3/*:: as any*/),
    (v4/*:: as any*/),
    (v5/*:: as any*/),
    (v6/*:: as any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "template",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subject",
      "storageKey": null
    },
    (v8/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "type": "EmailSettings",
  "abstractKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    (v7/*:: as any*/),
    (v8/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "type": "SlackSettings",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Recipient",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": true,
  "selections": [
    (v3/*:: as any*/),
    (v4/*:: as any*/),
    (v5/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tag",
      "storageKey": null
    },
    (v6/*:: as any*/)
  ],
  "storageKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "project",
      "storageKey": null
    },
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    (v8/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "type": "JiraSettings",
  "abstractKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "impact",
      "storageKey": null
    },
    (v12/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    (v8/*:: as any*/),
    (v9/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urgency",
      "storageKey": null
    }
  ],
  "type": "ServiceNowSettings",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    (v12/*:: as any*/),
    (v8/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "type": "MSTeamsSettings",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupBy",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schedule",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertReportGroupsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpsertReportGroupsPayload",
        "kind": "LinkedField",
        "name": "upsertReportGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportGroup",
            "kind": "LinkedField",
            "name": "reportGroups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "deliverySettings",
                "plural": true,
                "selections": [
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v13/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "storageKey": null
              },
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpsertReportGroupsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpsertReportGroupsPayload",
        "kind": "LinkedField",
        "name": "upsertReportGroups",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReportGroup",
            "kind": "LinkedField",
            "name": "reportGroups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "deliverySettings",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v13/*:: as any*/),
                  (v14/*:: as any*/),
                  (v15/*:: as any*/)
                ],
                "storageKey": null
              },
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "reportGroups",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "ReportGroupEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccad726abc8f7aaafbd7c90e9d81d925",
    "id": null,
    "metadata": {},
    "name": "UpsertReportGroupsMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertReportGroupsMutation(\n  $input: UpsertReportGroupsInput\n) {\n  upsertReportGroups(input: $input) {\n    reportGroups {\n      deliverySettings {\n        __typename\n        ... on EmailSettings {\n          firstMatchOnly\n          recipients {\n            account_owner\n            event_owner\n            resource_owner\n            value\n          }\n          subject\n          template\n          type\n        }\n        ... on SlackSettings {\n          firstMatchOnly\n          recipients {\n            account_owner\n            event_owner\n            resource_owner\n            value\n          }\n          template\n          type\n        }\n        ... on JiraSettings {\n          description\n          firstMatchOnly\n          project\n          recipients {\n            account_owner\n            event_owner\n            resource_owner\n            tag\n            value\n          }\n          summary\n          template\n          type\n        }\n        ... on ServiceNowSettings {\n          firstMatchOnly\n          impact\n          recipients {\n            account_owner\n            event_owner\n            resource_owner\n            tag\n            value\n          }\n          shortDescription\n          template\n          type\n          urgency\n        }\n        ... on MSTeamsSettings {\n          firstMatchOnly\n          recipients {\n            account_owner\n            event_owner\n            resource_owner\n            tag\n            value\n          }\n          template\n          type\n        }\n      }\n      enabled\n      groupBy\n      id\n      name\n      schedule\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "825a5430e16b2a42b2a93e35935e0102";

export default node;
